import React from 'react'
import { useMovieParam } from '../../hooks/useMovieParam'

export const Header = (): JSX.Element => {
  const movie = useMovieParam()
  return <span>{movie?.title}</span>
}
